var _stop, _stop2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-70 145.817 714.9729963378907 283.3518979278089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Livello_2",
    viewBox: "0 0 800.6499633789062 878.3299560546875",
    height: 143.35189792780892,
    width: 130.6737925240102,
    y: 215.817,
    x: 0,
    preserveAspectRatio: "xMinYMin",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_18",
    x1: 388.2,
    y1: 153.14,
    x2: 388.2,
    y2: 785.98,
    gradientUnits: "userSpaceOnUse",
    style: {}
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5bedd"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7486c1"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Livello_3",
    className: "cls-3",
    cx: 26.99,
    cy: 250.53,
    r: 26.99,
    style: {
      fill: "#dce9ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Livello_3",
    className: "cls-3",
    cx: 713.38,
    cy: 174.54,
    r: 26.99,
    style: {
      fill: "#dce9ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Livello_3",
    className: "cls-3",
    cx: 491.56,
    cy: 80.96,
    r: 26.99,
    style: {
      fill: "#dce9ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Livello_3",
    className: "cls-3",
    cx: 416.7,
    cy: 21.04,
    r: 21.04,
    style: {
      fill: "#dce9ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Livello_3",
    className: "cls-3",
    cx: 67.58,
    cy: 141.24,
    r: 33.3,
    style: {
      fill: "#dce9ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Livello_3",
    className: "cls-3",
    cx: 767.35,
    cy: 290.51,
    r: 33.3,
    style: {
      fill: "#dce9ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Livello_2-2",
    className: "cls-7",
    d: "M703.37,385.06c0-174.06-141.1-315.16-315.16-315.16S73.04,211,73.04,385.06c0,0-97.77,124.48-51.59,170.66,30.88,30.88,67.44,11.54,95.1-13.61,43.31,76.3,115.91,139.96,203.83,171.1,17.06,6.04,26.45,24.2,21.55,41.62-19.37,68.99-13.04,150.59,150.14,109.8,141.29-35.32,127.38-101.32,88.09-152.36-10.62-13.8-8.99-33.35,3.57-45.41,33.16-31.81,61.89-72.94,82.87-118.93,26.68,22.05,59.92,36.21,88.35,7.78,46.18-46.18-51.59-170.66-51.59-170.66Z",
    style: {
      fill: "url(#Sfumatura_senza_nome_18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Livello_2-2",
    className: "cls-2",
    d: "M6.77,640.04c48.65,115.54,148.26,204.35,270.7,238.29,0,0-19.37-13.81-26.09-33.11-1.85-5.32-3.32-10.39-4.47-14.93-3.3-12.99-13.17-23.28-25.93-27.37h0c-8.66-2.78-17.99-2.42-26.45,.92-8.67,3.41-21.01,5.53-31.53-3.08-10.15-8.31-11.51-21.52-10.67-31.73,.84-10.24-2.24-20.4-9.08-28.07l-.12-.13c-8.14-9.14-20.35-13.88-32.42-11.88-9.25,1.53-20.17,.85-27.03-7.9-7.28-9.27-6.89-19.94-4.9-27.96,2.26-9.09,.49-18.69-4.85-26.39h0c-6.17-8.91-16.33-14.06-27.16-14.05-10.32,.01-24.67-2.44-39.99-12.59Z",
    style: {
      fill: "#8e9d5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Livello_2-2",
    className: "cls-2",
    d: "M180.89,727.12s33.99,54.33,106.57,50.13c0,0-13.43-6.43-17.9-14.55-4.48-8.11-3.72-27.31-20.22-34.04-29.01-11.84-31.53,11.24-68.45-1.55Z",
    style: {
      fill: "#8e9d5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M158.93,492.43s-17.63,27.17-42.38,49.69c9.39,16.55,20.18,32.49,32.18,47.64,17.66-46.47,10.2-97.33,10.2-97.33Z",
    style: {
      fill: "#617db5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M666.61,547.94c-28.24-23.34-49.13-55.52-49.13-55.52,0,0-7.21,57.47,18,111.83,11.63-17.64,22.1-36.52,31.13-56.31,0,0,0,0,0,0Z",
    style: {
      fill: "#617db5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Livello_2-2",
    className: "cls-3",
    d: "M472.07,280.23c0-33.12-37.56-59.98-83.9-59.98-46.34,0-83.9,26.85-83.9,59.98v38.59s-6.81,41.95,40.99,41.95,42.91-41.95,42.91-41.95c0,0,5.82,41.95,40.49,41.95,34.67,0,43.41-41.95,43.41-41.95v-38.59Z",
    style: {
      fill: "#dce9ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Livello_2-2",
    className: "cls-2",
    d: "M662.98,788.89c49.03-43.59,87.62-98.66,111.56-161,0,0-11.83,19.01-29.18,22.37-17.34,3.36-30.4-1.76-36.74,14.23-6.34,15.98,12.68,27.17,2.61,41.15-10.07,13.99-24.2-2.24-39.72,15.66-15.52,17.9,9.22,32.23-8.53,67.58Z",
    style: {
      fill: "#8e9d5e"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Livello_4",
    className: "cls-1",
    cx: 198.18,
    cy: 368.79,
    rx: 32.47,
    ry: 26.19,
    style: {
      fill: "#f691d6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Livello_4",
    className: "cls-1",
    cx: 578.16,
    cy: 368.79,
    rx: 32.47,
    ry: 26.19,
    style: {
      fill: "#f691d6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Livello_4",
    className: "cls-5",
    cx: 545.13,
    cy: 259.82,
    rx: 53.65,
    ry: 68.29,
    style: {
      fill: "#061966"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Livello_4",
    className: "cls-4",
    cx: 534.5,
    cy: 233.25,
    rx: 24.28,
    ry: 19.58,
    transform: "translate(-8.39 446.24) rotate(-45)",
    style: {
      fill: "#173fa3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M356.46,281.03c2.2,2.45,5.24,3.7,8.29,3.7,2.64,0,5.3-.94,7.42-2.84,4.58-4.1,4.96-11.14,.86-15.71l-11.75-13.12c-4.1-4.58-11.14-4.96-15.71-.86-4.58,4.1-4.96,11.14-.86,15.71l11.75,13.12Z",
    style: {
      fill: "#061966"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M404.17,281.89c2.12,1.9,4.78,2.84,7.42,2.84,3.05,0,6.09-1.25,8.29-3.7l11.75-13.12c4.1-4.58,3.71-11.61-.86-15.71-4.58-4.1-11.61-3.71-15.71,.86l-11.75,13.12c-4.1,4.58-3.72,11.61,.86,15.71Z",
    style: {
      fill: "#061966"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M472.07,307.69c-6.15,0-11.13,4.98-11.13,11.13,0,17-13.83,30.82-30.82,30.82s-30.82-13.83-30.82-30.82c0-6.15-4.98-11.13-11.13-11.13s-11.13,4.98-11.13,11.13c0,17-13.83,30.82-30.82,30.82s-30.82-13.83-30.82-30.82c0-6.15-4.98-11.13-11.13-11.13s-11.13,4.98-11.13,11.13c0,29.27,23.81,53.08,53.08,53.08,17.05,0,32.23-8.09,41.95-20.62,9.72,12.53,24.9,20.62,41.95,20.62,29.27,0,53.08-23.81,53.08-53.08,0-6.15-4.98-11.13-11.13-11.13Z",
    style: {
      fill: "#061966"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Livello_4",
    className: "cls-6",
    d: "M357.07,435.34c19,5.8,45.41,11.46,71.75,9.2,9.91-.85,15.02,11.58,7.16,17.68-9.74,7.55-24.83,13.69-47.78,11.82-17.69-1.44-31.46-11.66-41.22-22.41-6.83-7.52,.38-19.26,10.09-16.29Z",
    style: {
      fill: "#617db5"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Livello_4",
    className: "cls-5",
    cx: 231.28,
    cy: 259.82,
    rx: 53.65,
    ry: 68.29,
    style: {
      fill: "#061966"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Livello_4",
    className: "cls-4",
    cx: 220.65,
    cy: 233.25,
    rx: 24.28,
    ry: 19.58,
    transform: "translate(-100.3 224.34) rotate(-45)",
    style: {
      fill: "#173fa3"
    }
  })), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 143.383,
    y: 261.05,
    viewBox: "5.929999828338623 23.579999923706055 431.5899963378906 52.87999725341797",
    height: 52.87999725341797,
    width: 431.5899963378906,
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#061966",
    fillOpacity: 1,
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93 75.55L14.59 75.55L14.59 55.42C14.59 50.86 13.81 44.16 13.35 39.60L13.61 39.60L17.45 50.93L24.94 71.18L30.48 71.18L37.90 50.93L41.81 39.60L42.14 39.60C41.62 44.16 40.90 50.86 40.90 55.42L40.90 75.55L49.69 75.55L49.69 27.29L39.01 27.29L31.00 49.89C29.96 52.88 29.11 56.07 28.07 59.13L27.74 59.13C26.77 56.07 25.86 52.88 24.81 49.89L16.61 27.29L5.93 27.29ZM69.75 76.46C73.92 76.46 77.57 74.37 80.76 71.64L81.02 71.64L81.67 75.55L89.48 75.55L89.48 54.25C89.48 43.70 84.73 38.16 75.48 38.16C69.75 38.16 64.54 40.31 60.24 42.98L63.69 49.30C67.08 47.35 70.34 45.85 73.72 45.85C78.22 45.85 79.78 48.58 79.97 52.17C65.26 53.73 58.94 57.83 58.94 65.65C58.94 71.83 63.24 76.46 69.75 76.46ZM72.88 68.97C70.08 68.97 68.06 67.73 68.06 64.87C68.06 61.61 71.05 59.13 79.97 58.03L79.97 65.39C77.63 67.67 75.61 68.97 72.88 68.97ZM99.25 75.55L108.83 75.55L108.83 50.47C111.50 47.80 113.38 46.37 116.38 46.37C119.96 46.37 121.53 48.32 121.53 53.99L121.53 75.55L131.10 75.55L131.10 52.82C131.10 43.63 127.71 38.16 119.83 38.16C114.88 38.16 111.17 40.77 107.98 43.89L107.78 43.89L107.07 39.08L99.25 39.08ZM149.99 76.46C154.15 76.46 157.80 74.37 160.99 71.64L161.25 71.64L161.90 75.55L169.72 75.55L169.72 54.25C169.72 43.70 164.96 38.16 155.72 38.16C149.99 38.16 144.78 40.31 140.48 42.98L143.93 49.30C147.32 47.35 150.57 45.85 153.96 45.85C158.45 45.85 160.01 48.58 160.21 52.17C145.49 53.73 139.17 57.83 139.17 65.65C139.17 71.83 143.47 76.46 149.99 76.46ZM153.11 68.97C150.31 68.97 148.29 67.73 148.29 64.87C148.29 61.61 151.29 59.13 160.21 58.03L160.21 65.39C157.87 67.67 155.85 68.97 153.11 68.97ZM191.60 76.46C194.79 76.46 197.33 75.74 199.29 75.09L197.72 68.12C196.75 68.51 195.31 68.90 194.14 68.90C190.88 68.90 189.19 66.95 189.19 62.78L189.19 46.63L198.18 46.63L198.18 39.08L189.19 39.08L189.19 29.24L181.25 29.24L180.14 39.08L174.47 39.53L174.47 46.63L179.62 46.63L179.62 62.78C179.62 70.92 182.94 76.46 191.60 76.46ZM220.26 76.46C224.75 76.46 229.37 74.89 232.96 72.42L229.70 66.56C227.09 68.19 224.49 69.10 221.49 69.10C216.09 69.10 212.18 65.97 211.40 59.98L233.87 59.98C234.13 59.13 234.32 57.38 234.32 55.55C234.32 45.52 229.11 38.16 219.08 38.16C210.42 38.16 202.09 45.52 202.09 57.31C202.09 69.36 210.03 76.46 220.26 76.46ZM211.27 53.60C211.99 48.32 215.37 45.59 219.21 45.59C223.90 45.59 226.12 48.71 226.12 53.60ZM258.09 76.46C262.59 76.46 267.21 74.89 270.79 72.42L267.54 66.56C264.93 68.19 262.33 69.10 259.33 69.10C253.93 69.10 250.02 65.97 249.24 59.98L271.71 59.98C271.97 59.13 272.16 57.38 272.16 55.55C272.16 45.52 266.95 38.16 256.92 38.16C248.26 38.16 239.92 45.52 239.92 57.31C239.92 69.36 247.87 76.46 258.09 76.46ZM249.11 53.60C249.82 48.32 253.21 45.59 257.05 45.59C261.74 45.59 263.96 48.71 263.96 53.60ZM295.61 75.55L324.85 75.55L324.85 67.47L305.25 67.47L305.25 27.29L295.61 27.29ZM341.46 76.46C345.62 76.46 349.27 74.37 352.46 71.64L352.72 71.64L353.37 75.55L361.19 75.55L361.19 54.25C361.19 43.70 356.43 38.16 347.19 38.16C341.46 38.16 336.25 40.31 331.95 42.98L335.40 49.30C338.79 47.35 342.04 45.85 345.43 45.85C349.92 45.85 351.48 48.58 351.68 52.17C336.96 53.73 330.64 57.83 330.64 65.65C330.64 71.83 334.94 76.46 341.46 76.46ZM344.58 68.97C341.78 68.97 339.76 67.73 339.76 64.87C339.76 61.61 342.76 59.13 351.68 58.03L351.68 65.39C349.34 67.67 347.32 68.97 344.58 68.97ZM389.26 76.46C397.27 76.46 404.76 69.23 404.76 56.66C404.76 45.52 399.35 38.16 390.37 38.16C386.78 38.16 383.14 39.92 380.27 42.53L380.53 36.67L380.53 23.58L370.96 23.58L370.96 75.55L378.45 75.55L379.29 71.70L379.55 71.70C382.48 74.76 386.00 76.46 389.26 76.46ZM387.11 68.58C385.16 68.58 382.81 67.86 380.53 65.84L380.53 49.82C383.01 47.28 385.22 46.04 387.70 46.04C392.71 46.04 394.92 49.89 394.92 56.85C394.92 64.80 391.54 68.58 387.11 68.58ZM422.99 76.46C432.50 76.46 437.52 71.31 437.52 64.93C437.52 58.16 432.18 55.75 427.36 53.92C423.51 52.49 420.13 51.51 420.13 48.84C420.13 46.76 421.69 45.33 425.01 45.33C427.68 45.33 430.22 46.57 432.83 48.45L437.13 42.66C434.13 40.38 430.03 38.16 424.75 38.16C416.42 38.16 411.14 42.79 411.14 49.30C411.14 55.42 416.29 58.22 420.91 59.98C424.75 61.48 428.53 62.72 428.53 65.45C428.53 67.73 426.90 69.29 423.25 69.29C419.87 69.29 416.74 67.86 413.48 65.32L409.12 71.31C412.77 74.31 418.11 76.46 422.99 76.46Z",
    transform: "translate(0, 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.35f2ba23ab78b379bc52410d9f4f430d.svg";
export { ForwardRef as ReactComponent };